import { Component, Prop, h, Watch, Element } from '@stencil/core';
import { handleAriaLabelChange } from '../../../shared/aria-utils';

@Component({
  tag: 'a1-file-icon',
  styleUrl: '../a1-icon.scss',
  scoped: true,
})
export class a1FileIcon {
  @Element() host!: HTMLA1FileIconElement;
  /**
   * Icon type. 'inherit' uses the parent element's font color.
   */
  @Prop({ reflect: true }) type: 'inherit' | 'primary' | 'secondary' = 'inherit';

  /**
   * File type displayed as text overlay on file icons.
   */
  @Prop() fileType: string = 'pdf';

  /**
   * Icon size. For file icons: 's' or 'm' is valid
   *
   */
  @Prop({ reflect: true }) size: 's' | 'm' = 'm';

  /**
   * Toggle for enabled / disabled icon appearance.
   */
  @Prop({ reflect: true }) disabled: boolean = false;

  /**
   * An alternate description to use for assistive devices. If omitted, the icon will be considered presentational and ignored by assistive devices.
   */
  @Prop() label: string = '';

  /**
   * When true, displays the icon in inverse colors for use on dark backgrounds.
   */
  @Prop({ reflect: true }) inverse: boolean = false;

  private get classNames() {
    return {
      icon: true,
      file: true,
      [`c-icon--file`]: true,
      [this.type]: true,
      [this.size]: true,
      disabled: this.disabled,
      inverse: this.inverse,
    };
  }
  @Watch('label')
  getAriaLabelChange() {
    handleAriaLabelChange(this.host, this.label);
  }

  componentDidLoad() {
    this.getAriaLabelChange();
  }

  render() {
    return (
      <i class={this.classNames}>
        <span class="file-icon-box">{this.fileType}</span>
      </i>
    );
  }
}
